// import { CUSTOMERLIST , CUSTOMERSTATUS } from "../../Constants/CustomerConstants";
import { SALONLIST , SALONDETAILS , SALONSTATUS , SALONAPPROVEDSTATUS ,DELETEBUSINESS ,SALONUPFDATE  ,SALONDELETE, SALONSUBSCRIPTIONMANAGE } from "../../Constants/SalonConstants";
import { createGetDataReducer } from "./CommonReducer";


export const SalonGetReducer = createGetDataReducer( SALONLIST );
export const SalonStatusGetReducer = createGetDataReducer(SALONSTATUS );
export const SalonDetailGetReducer = createGetDataReducer(SALONDETAILS)
export const SalonApprovedStatusGetReducer = createGetDataReducer(SALONAPPROVEDSTATUS)
export const SalonBussianImageGetReducer = createGetDataReducer(DELETEBUSINESS)
export const SalonUpdateReducer = createGetDataReducer(SALONUPFDATE)
export const SalonDeleteReducer = createGetDataReducer(SALONDELETE)
export const SalonSubscriptionManageReducer = createGetDataReducer(SALONSUBSCRIPTIONMANAGE)



